import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EventSummary from './EventSummary';
import { Box, Divider, Alert, AlertTitle, Link } from '@mui/material';
import { useTicketsSelected } from '@/store';
import TicketsSelector from '../tickets/TicketsSelector';
import useEventStatus from '@/contexts/event/useEventStatus';
import MsciBanner from '@/sections/msi/MsciBanner';
import MsiPreSale from '@/sections/msi/MsiPreSale';
import useEventContext from '@/contexts/event/useEventContext';
import Fan2FanTickets from '@/sections/secondary-market/Fan2FanTickets';
import useEventAlerts from '@/hooks/checkout/useEventAlerts';
import EventAlert from '../EventAlert';
import { useCustomLinksActions } from '@/store';

export default function EventHome({ onReadMore, onTicketCategorySelected }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { hasTickets } = useTicketsSelected();
  const { eventStatus } = useEventStatus();
  const { alert } = useEventAlerts(eventStatus);
  const {
    customLink: { linkStatus },
  } = useCustomLinksActions();

  const { event } = useEventContext();

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'scroll',
      }}
    >
      <Box
        sx={{
          mr: '24px',
          ml: '24px',
          mb: 2,
        }}
      >
        <EventSummary onReadMore={onReadMore} />
      </Box>

      <Box
        sx={{
          mr: '24px',
          ml: '24px',
          mb: 2,
        }}
      >
        <MsciBanner />
      </Box>

      <Box
        sx={{
          ml: '24px',
          mr: '24px',
        }}
      >
        <Divider />
      </Box>

      <Box
        sx={{
          mr: '24px',
          ml: '24px',
        }}
      >
        {eventStatus === 'pre-sale' && <MsiPreSale />}
        {(linkStatus === 'active' || !linkStatus) &&
          eventStatus === 'active' && (
            <TicketsSelector
              onTicketCategorySelected={onTicketCategorySelected}
            />
          )}
        {event?.secondary_market?.has && (
          <Fan2FanTickets link={event.secondary_market.link} />
        )}
        {alert && (
          <EventAlert
            title={t(alert.title)}
            message={t(alert.message)}
            hasLink={alert.link}
          />
        )}
      </Box>
      {show && hasTickets && (
        <Box
          sx={{
            height: '77px',
            width: '100%',
          }}
        ></Box>
      )}
    </Box>
  );
}
